module.exports = __webpack_public_path__ + "media/images/countrysquared/lv-9f3207c1f8bd2fa99af4312a3330e31f.svg";